import {
  Cloud,
  Target,
  Users,
  MessageCircle,
  Lightbulb,
  Handshake,
} from 'lucide-react';

export const DATA_FR = {
  cvPdf: "/pierre-touzeau_fr.pdf",

  personal: {
    name: "Pierre Touzeau",
    role: "Cloud DevOps Engineer - Ingénieur Backend",
    location: "Bordeaux, France",
    email: "pierre.touzeau@outlook.fr",
    linkedin: "linkedin.com/in/pierre-touzeau",
    github: "github.com/pierretouzeaufr",
    availability: "Disponible",
    summary: "Passionné par le développement backend et les nouvelles technologies, je combine expertise DevOps et programmation pour créer des solutions cloud innovantes et scalables. Toujours à l'affût des techs de demain pour relever de nouveaux défis techniques."
  },

  experiences: [
    {
      id: 1,
      company: "Capgemini",
      role: "Ingénieur Backend / DevOps",
      period: "2024 - Aujourd'hui",
      duration: "En cours",
      location: "Bordeaux",
      description: "Pour un client grand compte leader dans la téléphonie, travail dans l'équipe Backend (N3) pour la création d'une solution de provisionnement et d'orchestration d'un cloud privé nouvelle génération (à terme + de 30 000 machines virtuelles, volumes, gestion des flux, load balancers, infrastructure ultra sécurisée, etc.). Développement de la solution en suivant les besoins clients, automatisation des process et périodes d'innovation.",
      achievements: [
        "Conception d'une solution backend from scratch",
        "Développement d'APIs REST",
        "Architecture cloud native sécurisée"
      ],
      skills: ["Kubernetes", "IA", "Docker", "Python", "GoLang", "Terraform (Provider)" , "Terraform (Client)", "GitLab CI", "Backend", "Cloud", "Agile"],
      current: true
    },
    {
      id: 2,
      company: "Capgemini",
      role: "Apprenti puis Ingénieur DevOps",
      period: "2022 - 2024",
      duration: "2 ans",
      location: "Bordeaux",
      description: "Pour un client grand compte, travail dans l'équipe Services (N2) pour automatiser un maximum de tâches sur un cloud privé de 20 000 machines virtuelles.",
      skills: ["PowerShell", "Bash", "Cloud", "Docker", "GitLab CI"],
      current: false
    },
    {
      id: 3,
      company: "Assystem",
      role: "Apprenti puis Technicien Informatique Industrielle",
      period: "2020 - 2022",
      duration: "2 ans",
      location: "Paris",
      description: "Dans le bureau d'études des calculateurs de CNPE, travail sur la conception et la maintenance de bancs de tests.",
      skills: ["Bash", "Électronique", "Automatismes", "Réseaux", "Systèmes"],
      current: false
    },
    {
      id: 4,
      company: "EDF",
      role: "Apprenti Informatique Industrielle & Électronique",
      period: "2018 - 2020",
      duration: "2 ans",
      location: "Centrale Nucléaire du Blayais",
      description: "Apprentissage en lien avec mon DUT dans le service automatismes d'un CNPE : maintenance de calculateurs et de cartes électroniques.",
      skills: ["Électronique", "Automatismes"],
      current: false
    }
  ],

  skills: {
    languages: [
      { name: "Python", level: 60 },
      { name: "GoLang", level: 45 },
      { name: "Bash", level: 80 },
      { name: "PowerShell", level: 95 },
    ],
    infrastructure: [
      { name: "Kubernetes - Partie Dev", level: 70 },
      { name: "Docker", level: 80 },
      { name: "Terraform", level: 90 },
      { name: "Ansible", level: 60 },
    ],
    cloud: [
      { name: "Google Cloud", level: 70 },
      { name: "GitLab CI", level: 90 },
      { name: "VMware", level: 60 },
      { name: "ELK Stack", level: 55 },
    ],
    soft: [
      { name: "Autonomie", icon: Target },
      { name: "Esprit d'équipe", icon: Users },
      { name: "Communication", icon: MessageCircle },
      { name: "Proactivité", icon: Lightbulb },
      { name: "Résolution de problèmes", icon: Handshake },
      { name: "Innovation", icon: Lightbulb },
    ]
  },

  certifications: [
    {
      name: "Associate Cloud Engineer",
      provider: "Google Cloud",
      date: "Mai 2024",
      icon: Cloud,
      verified: true
    }
  ],

  stats: {
    deployments: "10k+",
    terraformResources: "5k+",
    commits: "3k+",
    uptime: "99.9%"
  },

  pipeline: [
    { stage: "Apprenti DevOps", status: "passed", duration: "2 ans" },
    { stage: "Ingénieur DevOps", status: "passed", duration: "3 ans" },
    { stage: "Ingénieur Cloud DevOps / N3-Backend", status: "running", duration: "En cours" },
  ],

  projects: [
    {
      id: 1,
      name: "Cloud Manager",
      description: "API et logiciel backend pour le provisionnement et l'orchestration d'un cloud privé",
      tech: ["Kubernetes", "Docker", "Python", "MariaDB", "Redis", "RabbitMQ", "Go", "Terraform", "API REST"],
      stars: 0,
      forks: 0,
      status: "En cours",
      github: ""
    },
    {
      id: 2,
      name: "Provider 'maison'",
      description: "Création d'un provider terraform adapté à l'application du client, Création puis maintenance de celui-ci pour l'adapter aux API",
      tech: ["Go", "Terraform"],
      stars: 0,
      forks: 0,
      status: "En cours",
      github: ""
    },
    {
      id: 3,
      name: "Scripts de gestion des machines virtuelles dormantes",
      description: "Script de détection, sauvegarde, suppression et communication des VM dormantes en se basant sur des métriques avancées fournies par la stack VMware",
      tech: ["VMware", "Vrops", "Powershell", "SMTP", "Gitlab-CI"],
      stars: 0,
      forks: 0,
      status: "Fini",
      github: ""
    },
    {
      id: 4,
      name: "Scripts de reporting général d'un cloud privé",
      description: "Génération quotidienne à partir de scripts de l'ensemble des données des backends du client, de la stack VMware, des données clients, etc.",
      tech: ["Python", "Powershell", "Gitlab-CI", "Linux", "Windows"],
      stars: 0,
      forks: 0,
      status: "Fini",
      github: ""
    }
  ]
};
